"use client";

import type { SupStoredAction } from "@/store/types";
import React from "react";

import { SupXCircle } from "@repo/core-ui";
import { useStoredDataDispatch } from "@/store";

interface GridBarFiltersAtomClearProps {
  dispatchAction: SupStoredAction;
}

export default function GridBarFiltersAtomClear({ dispatchAction }: GridBarFiltersAtomClearProps) {
  const storedDispatch = useStoredDataDispatch();
  return (
    <button
      className="btn-icon sup-icon mx-1 h-[20px] w-[20px] rounded-full hover:bg-transparent"
      onClick={event => {
        event.stopPropagation();
        storedDispatch(dispatchAction);
      }}
    >
      <SupXCircle />
    </button>
  );
}
